import { render, staticRenderFns } from "./TemplateDocument.vue?vue&type=template&id=6e849c00&scoped=true&"
import script from "./TemplateDocument.vue?vue&type=script&lang=js&"
export * from "./TemplateDocument.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDocument.vue?vue&type=style&index=0&id=6e849c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e849c00",
  null
  
)

export default component.exports